/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_FreeInputs */

const en_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const de_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const fr_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const es_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const it_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const nl_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const pl_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmo`)
};

const fi_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen`)
};

const da_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const sv_common_free = /** @type {(inputs: Common_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Common_FreeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_free = /** @type {((inputs?: Common_FreeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_FreeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_free(inputs)
	if (locale === "fr") return fr_common_free(inputs)
	if (locale === "es") return es_common_free(inputs)
	if (locale === "it") return it_common_free(inputs)
	if (locale === "nl") return nl_common_free(inputs)
	if (locale === "pl") return pl_common_free(inputs)
	if (locale === "fi") return fi_common_free(inputs)
	if (locale === "da") return da_common_free(inputs)
	if (locale === "sv") return sv_common_free(inputs)
	return en_common_free(inputs)
});